import {PopupDropdown} from '@wandb/weave/common/components/PopupDropdown';
import {
  hexToRGB,
  MOON_500,
  MOON_600,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {IconDelete, IconSort} from '@wandb/weave/components/Icon';
import React from 'react';

import {BackLink} from '../../BackLink';
import {Chip} from '../Chip';
import {ActiveChip} from '../Queues/ActiveChip';
import {EntityChip} from '../Queues/EntityChip';
import {PrioritizationChip} from '../Queues/PrioritizationChip';
import {isQueuePrioritizationEnabled, Queue} from '../Queues/queueUtil';
import {ResourceChip} from '../ResourceChip';
import * as S from './QueueDetailHeader.styles';

type QueueDetailHeaderProps = {
  queue: Queue;
  onDelete: (queue: Queue) => void;
  onEnablePrioritization: (queue: Queue) => void;
};

export const QueueDetailHeader = ({
  queue,
  onDelete,
  onEnablePrioritization,
}: QueueDetailHeaderProps) => {
  const {name, entityName, resourceType, status, items} = queue;
  const queueSupportsPrioritization = isQueuePrioritizationEnabled(queue);

  const isEmpty = items.length === 0;

  const menuOptions = React.useMemo(
    () => [
      ...(!queueSupportsPrioritization
        ? [
            {
              key: 'enable-prioritization',
              text: 'Enable prioritization',
              icon: <IconSort style={{marginRight: '4px'}} />,
              onClick: () => {
                onEnablePrioritization(queue);
              },
            },
          ]
        : []),
      {
        key: 'delete-queue',
        text: 'Delete queue',
        icon: <IconDelete style={{marginRight: '4px'}} />,
        onClick: () => {
          onDelete(queue);
        },
      },
    ],
    [onDelete, onEnablePrioritization, queue, queueSupportsPrioritization]
  );

  return (
    <S.QueueHeader>
      <S.LefthandPanel>
        <BackLink to="/launch" text="Launch" />

        <S.QueueNamePanel>
          <S.QueueName>{name}</S.QueueName>
          <EntityChip name={entityName} />
          <Chip icon="queue" label="Queue" />
          <ResourceChip value={resourceType} />
          <ActiveChip status={status} />
          {queueSupportsPrioritization && <PrioritizationChip />}
          {isEmpty && (
            <Chip
              label="Empty"
              color={MOON_600}
              backgroundColor={hexToRGB(MOON_500, 0.14)}
            />
          )}
        </S.QueueNamePanel>
      </S.LefthandPanel>
      <S.RighthandPanel>
        <PopupDropdown
          position="bottom right"
          trigger={
            <Button
              icon="overflow-horizontal"
              variant="ghost"
              style={{marginRight: '8px'}}
            />
          }
          options={menuOptions}
        />
      </S.RighthandPanel>
    </S.QueueHeader>
  );
};
